import {Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import { MatCheckboxChange, MatCheckbox } from "@angular/material/checkbox";
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import {DonationReportRequest} from "@portal/api/requests/donations/donation-report-request";
import {DateUtils} from "../../modules/admin/shared/helpers/date-utils";
import {DropdownDataService} from "@portal/shared/services/dropdown-data-service";
import {Observable} from "rxjs";
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FormsModule } from '@angular/forms';
import { MatFormField, MatLabel, MatSuffix, MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatDateRangePicker } from '@angular/material/datepicker';
import { MatButton } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-donations-report-modal',
    templateUrl: './donations-report-modal.component.html',
    styleUrls: ['./donations-report-modal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatCheckbox, FormsModule, MatFormField, MatLabel, MatSelect, MatOption, MatDateRangeInput, MatStartDate, MatEndDate, MatDatepickerToggle, MatSuffix, MatDateRangePicker, MatInput, MatDialogActions, MatButton, MatDialogClose, AsyncPipe]
})
export class DonationsReportModalComponent implements OnInit {
    locationsOptions$: Observable<{ label: string; value: string }[]> = this._dropdownDataService.locationsData$;
    hasPaidListing = false;
    hasPromisedListing = false;
    hasToContactListing = false;
    groupByLocation = false;
    hidePaidValue = false;
    hideResponsiblePerson = false;
    filterByDates = false;
    valuesInterval = false;
    locationId = '';
    onlySpecialDonorRole = false;
    startDate: Date;
    endDate: Date;
    maxValue: number = null;
    minValue: number = null;

    constructor(
        private _dropdownDataService: DropdownDataService,
        public dialogRef: MatDialogRef<DonationsReportModalComponent>) {
    }

    ngOnInit(): void {
        this._dropdownDataService.getPartyLocations().subscribe();
    }

    get hasAnyListingSelected(): boolean {
        return this.hasPaidListing || this.hasPromisedListing || this.hasToContactListing;
    }

    onFilterByDatesChange(event: MatCheckboxChange) {
        if (!event.checked) {
            this.startDate = null;
            this.endDate = null;
        }
    }

    confirmSelection() {
        const hasAnyListingSelected = this.hasPaidListing || this.hasPromisedListing || this.hasToContactListing;
        const includePaid = hasAnyListingSelected ? this.hasPaidListing : true;
        const includePromised = hasAnyListingSelected ? this.hasPromisedListing : true;
        const includeToContact = hasAnyListingSelected ? this.hasToContactListing : true;
        const canUseValueInterval = this.hasPaidListing || this.hasPromisedListing;
        const result = {
            images: [],
            hasPaidListing: includePaid,
            hasPromisedListing: includePromised,
            groupByLocation: this.groupByLocation,
            hidePaidValue: includePaid ? this.hidePaidValue : false,
            filterByDates: this.filterByDates,
            hideResponsiblePerson: this.hideResponsiblePerson,
            hasToContactListing: includeToContact,
            startDate: this.filterByDates ? DateUtils.momentDateToString(this.startDate) : null,
            endDate: this.filterByDates ? DateUtils.momentDateToString(this.endDate) : null,
            valuesInterval: (includePaid || includePromised) && this.valuesInterval,
            minValue: (includePaid || includePromised) && this.valuesInterval ? this.minValue : null,
            maxValue: (includePaid || includePromised) && this.valuesInterval ? this.maxValue : null,
            locationId: this.locationId || null,
            hasSpecialDonorRole: this.onlySpecialDonorRole ? true : null,
        } as DonationReportRequest;

        this.dialogRef.close(result);
    }
}
